var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('competition-detail-component',{attrs:{"competition-type":'competitionDetail',"competition-key":_vm.competitionKey}}),_c('share-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }